var map = {
	"./de/pages/welcome": [
		"25rl",
		52
	],
	"./en/pages/welcome": [
		"WlPE",
		36
	],
	"./fr/pages/welcome": [
		"LysT",
		20
	],
	"./nl/pages/welcome": [
		"c16P",
		4
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "VW8d";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang lazy ^\.\/.*\/pages\/welcome$
// module id = VW8d
// module chunks = 97